import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate'

import auth from "./modules/auth";
import alert from "./modules/alert";
import user from "./modules/user";
import message from "./modules/message";
import review from "./modules/review";
import order from "./modules/order";
import product from "./modules/product";
import article from "./modules/article";
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        alert,
        user,
        message,
        review,
        order,
        product,
        article,
    },
    plugins: [createPersistedState({
        key: 'piachu',
        paths: ['auth.token', 'auth.user_type', 'auth.identification_flg'],
        storage: window.localStorage
    })]
});


// WEBPACK FOOTER //
// ./src/store/index.js